/*!

 =========================================================
 * Paper Dashboard Pro Angular - v1.7.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/paper-dashboard-pro-angular
 * Copyright 2020 Creative Tim (http://www.creative-tim.com)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import { ApplicationConfig, enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';

import { environment } from './environments/environment';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi, withInterceptors } from '@angular/common/http';
// import { MsalInterceptor, MSAL_INSTANCE, MsalInterceptorConfiguration, MsalGuardConfiguration, MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG, MsalService, MsalGuard, MsalBroadcastService, MsalModule } from '@azure/msal-angular';
// import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { withHashLocation, provideRouter, withComponentInputBinding } from '@angular/router';
import { AppRoutes } from './app/app.routing';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideKeycloak, 
        withAutoRefreshToken, 
        AutoRefreshTokenService, 
        UserActivityService, 
        createInterceptorCondition, 
        IncludeBearerTokenCondition, 
        INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
        includeBearerTokenInterceptor } from 'keycloak-angular';

const protectedResourceMap = new Map<string, Array<string>>(Object.entries(environment.msalConfig.endpoints));

const urlCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  // urlPattern: /^(http:\/\/localhost:80\/eupid)(\/.*)?$/i,
  urlPattern: /^(https?:\/\/(localhost|(internal-|external-)?ait-eupid-reverse-proxy\.germanywestcentral\.cloudapp\.azure\.com)(:80)?(\/eupid)?)(\/.*)?$/i,
  bearerPrefix: 'Bearer'
});

/*
function loggerCallback(logLevel: LogLevel, message: string) {
    if (logLevel == LogLevel.Error) {
        console.error(message);
    }
}
*/
/*
function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.clientId,
      authority: environment.msalConfig.authority,
      redirectUri: environment.msalConfig.redirectUri,
      postLogoutRedirectUri: environment.msalConfig.postLogoutRedirectUri
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage
    },
    system: {
      allowPlatformBroker: false, // Disables WAM Broker
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>(Object.entries(environment.msalConfig.endpoints));

    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap
    };
}

function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
        scopes: [`${environment.msalConfig.clientId}/.default`]
    },
    loginFailedRoute: '/login-failed'
  };
}
*/

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        importProvidersFrom(BrowserModule),
        /*{
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MSALInterceptorConfigFactory
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService,
        */
        provideHttpClient(
          withInterceptors([includeBearerTokenInterceptor]),
          withInterceptorsFromDi(),
          withFetch()
        ),
        {
          provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
          useValue: [urlCondition] // <-- Note that multiple conditions might be added.
        },
        provideAnimations(),
        provideKeycloak({
          config: {
            url: environment.keycloakConfig.url,
            realm: environment.keycloakConfig.realm,
            clientId: environment.keycloakConfig.clientId
          },
          initOptions: {
            onLoad: 'check-sso',
            redirectUri: window.location.href,
            silentCheckSsoFallback: true,
            enableLogging: false,
            checkLoginIframe: false,
	          scope: environment.keycloakConfig.scope
          },
          features: [
            withAutoRefreshToken({
              onInactivityTimeout: 'logout',
              sessionTimeout: 300000
            })
          ],
          providers: [
            AutoRefreshTokenService,
            UserActivityService
          ]
        }),
        provideRouter(AppRoutes, withComponentInputBinding())
        // provideRouter(AppRoutes, withHashLocation())
    ]
}).catch((err) => {
  console.error("bootstrapApplication error");
  console.error(err);
});
